import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

// keepMounted: once a tab has been activated, keep its children mounted while
// hidden so mounted-once components don't refetch on every tab switch.
// preload: mount children immediately (hidden) before first activation so their
// initial data loads up front, avoiding a spinner on first open.
const TabPanel = ({ children, value, index, keepMounted = false, preload = false, ...other }) => {
  const isActive = value === index;
  const [hasBeenActive, setHasBeenActive] = useState(isActive || preload);

  useEffect(() => {
    if (isActive) {
      setHasBeenActive(true);
    }
  }, [isActive]);

  const shouldRender = isActive || ((keepMounted || preload) && hasBeenActive);

  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      style={{ marginTop: '30px' }} // Add 20px top margin
      {...other}
    >
      {shouldRender && (
        <Box>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export default TabPanel;